import { useEffect, useState } from "react";
// import axios from "axios";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png";
import api from "../services/api";
import { useNavigate } from "react-router-dom";


// const API = "http://localhost:5000/api";

const Login = () => {

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Login | JKS Garments";
  }, []);

  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      alert("Username & password required");
      return;
    }

    try {
      const res = await api.post("/auth/login", {
        username: username.trim(),
        password: password.trim()
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      console.log(res.data);
      login(res.data);

if (res.data.user.role === "CASHIER") {
  navigate("/billing");
} else {
  navigate("/");
}

    } catch (err) {
      console.error("LOGIN ERROR:", err);
      alert(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* LOGO */}
        <img
          src={logo}
          alt="Retail POS"
          style={styles.logo}
        />

        <h2 style={styles.title}>JKS Garments</h2>
        <p style={styles.subtitle}>Admin Login</p>
<div className="form-row">
        <input
          style={styles.input}
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleLogin()}
        />
</div>
<div className="form-row">
        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleLogin()}
        />
</div>
        <button
          style={{
            ...styles.button,
            opacity: loading ? 0.7 : 1
          }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <div style={styles.footer}>
          © {new Date().getFullYear()} Retail POS
        </div>
      </div>
    </div>
  );
};

/* ================= STYLES ================= */

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #1e293b, #0f172a)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  card: {
    width: 360,
    background: "#fff",
    padding: "30px 30px 35px",
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
    textAlign: "center"
  },
  logo: {
    width: 90,
    height: "auto",
    marginBottom: 10
  },
  title: {
    margin: 0,
    fontSize: 24,
    fontWeight: 700,
    color: "#1e293b"
  },
  subtitle: {
    marginBottom: 20,
    color: "#64748b"
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    marginBottom: 12,
    borderRadius: 6,
    border: "1px solid #cbd5e1",
    fontSize: 14,
    outline: "none"
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    fontSize: 15,
    cursor: "pointer",
    marginTop: 10
  },
  footer: {
    marginTop: 18,
    fontSize: 12,
    color: "#94a3b8"
  }
};

export default Login;
